import { apiBaseUrl } from '@/logic/configuration.ts'

export const stripBaseApiUrl = (url: string): string =>
  url.startsWith(apiBaseUrl) ? url.slice(apiBaseUrl.length) : url
